import { Fragment, type FC } from 'react';

import { type ViewModelProps } from '#packages/web/types/view-model-props';
import { type LoggingContext } from '#packages/data-collection/types/logging-context';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type AuditCreatePageViewModel } from './audit-create-page.view-model';
import { AuditCreatePageRenderer } from './audit-create-page.renderer';

export type AuditCreatePageContainerProps =
  ViewModelProps<AuditCreatePageViewModel> & LoggingContext;

export const AuditCreatePageContainer: FC<AuditCreatePageContainerProps> = ({
  viewModel,
}) => {
  const { page, form } = viewModel;

  return (
    <Fragment>
      {/* Always show the form */}
      <AuditCreatePageRenderer
        isPending={page.state === 'pending'}
        form={form}
        onSubmit={viewModel.onSubmit}
      />

      {/* Error */}
      {page.state === 'error' && <ThrowError error={page.error} />}
    </Fragment>
  );
};
